const x = "foil:theme";
class q extends HTMLElement {
  connectedCallback() {
    var e;
    const t = this._getSaved();
    (t && document.documentElement.setAttribute("data-theme", t),
      this._updateIcons(),
      (this.button = this.querySelector("button")),
      (e = this.button) == null ||
        e.addEventListener("click", this._toggle.bind(this)));
  }
  disconnectedCallback() {
    var t;
    (t = this.button) == null || t.removeEventListener("click", this._toggle);
  }
  _toggle() {
    const e =
      (document.documentElement.getAttribute("data-theme") || "dark") === "dark"
        ? "light"
        : "dark";
    (document.documentElement.setAttribute("data-theme", e),
      this._save(e),
      this._updateIcons());
  }
  _updateIcons() {
    const t = document.documentElement.getAttribute("data-theme") || "dark",
      e = this.querySelector('[data-icon="dark"]'),
      s = this.querySelector('[data-icon="light"]');
    (e && (e.hidden = t !== "light"), s && (s.hidden = t !== "dark"));
  }
  _getSaved() {
    try {
      return localStorage.getItem(x);
    } catch {
      return null;
    }
  }
  _save(t) {
    try {
      localStorage.setItem(x, t);
    } catch {}
  }
}
customElements.define("tcg-dark-mode-toggle", q);
var L;
const C = ((L = window.Foil) == null ? void 0 : L.routes) ?? {
  cart_url: "/cart",
  cart_change_url: "/cart/change",
};
function T(r) {
  document.dispatchEvent(new CustomEvent("cart:updated", { detail: r }));
}
async function M(r, t) {
  const e = await fetch(r, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(t),
    }),
    s = await e.json();
  if (!e.ok) {
    const n = new Error(s.description || s.message || "Cart error");
    throw ((n.status = e.status), n);
  }
  return s;
}
async function A() {
  const response = await fetch(`${C.cart_url}.js`, {headers:{Accept:'application/json'}});
  if (!response.ok) throw new Error(window.Foil.strings.cart_error);
  return response.json();
}
let cartChanging = false;
function cartBusy(busy) {
  document.querySelectorAll('tcg-cart-drawer button, tcg-cart-drawer input').forEach(el => el.disabled = busy);
  document.querySelectorAll('tcg-cart-drawer a[href$="/checkout"]').forEach(el => {
    el.setAttribute('aria-disabled', String(busy));
    el.style.pointerEvents = busy ? 'none' : '';
    el.tabIndex = busy ? -1 : 0;
  });
}
async function v(r, t) {
  if (cartChanging) return;
  cartChanging = true;
  cartBusy(true);
  try { const cart = await M(C.cart_change_url + '.js', {id:r,quantity:t}); T(cart); return cart; }
  finally { cartChanging = false; cartBusy(false); }
}
async function w(r) {
  return v(r, 0);
}
function p(r, t) {
  var o;
  const e =
      ((o = window.Foil) == null ? void 0 : o.money_format) || "${{amount}}",
    s = (r / 100).toFixed(2),
    n = Math.round(r / 100).toString(),
    i = s.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
    a = n.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return e
    .replace("{{amount_with_comma_separator}}", i)
    .replace("{{amount_no_decimals_with_comma_separator}}", a)
    .replace("{{amount_no_decimals}}", n)
    .replace("{{amount}}", s);
}
const O = [
  "a[href]",
  "button:not([disabled])",
  'input:not([disabled]):not([type="hidden"])',
  "select:not([disabled])",
  "textarea:not([disabled])",
  '[tabindex]:not([tabindex="-1"])',
].join(", ");
let m = null;
function _(r) {
  m = document.activeElement;
  const t = r.querySelectorAll(O);
  if (t.length === 0) return;
  const e = t[0],
    s = t[t.length - 1];
  (e.focus(),
    (r._focusTrapHandler = (n) => {
      n.key === "Tab" &&
        (n.shiftKey
          ? document.activeElement === e && (n.preventDefault(), s.focus())
          : document.activeElement === s && (n.preventDefault(), e.focus()));
    }),
    r.addEventListener("keydown", r._focusTrapHandler));
}
function f(r) {
  (r._focusTrapHandler &&
    (r.removeEventListener("keydown", r._focusTrapHandler),
    delete r._focusTrapHandler),
    m && m.focus && (m.focus(), (m = null)));
}
class j extends HTMLElement {
  connectedCallback() {
    ((this._onOpen = this._open.bind(this)),
      (this._onCartUpdated = this._handleCartUpdate.bind(this)),
      (this._onKeydown = this._handleKeydown.bind(this)),
      document.addEventListener("cart:open", this._onOpen),
      document.addEventListener("cart:updated", this._onCartUpdated));
  }
  disconnectedCallback() {
    (document.removeEventListener("cart:open", this._onOpen),
      document.removeEventListener("cart:updated", this._onCartUpdated),
      document.removeEventListener("keydown", this._onKeydown));
  }
  async _open(event) {
    ((this.hidden = !1),
      this.classList.add("pointer-events-auto"),
      (document.body.style.overflow = "hidden"));
    try {
      const t = event?.detail?.items ? event.detail : await A();
      this._render(t);
    } catch {
      location.assign(C.cart_url);
      return;
    }
    (document.addEventListener("keydown", this._onKeydown),
      requestAnimationFrame(() => {
        const t = this.querySelector("[data-drawer-panel]");
        t && _(t);
      }));
  }
  _close() {
    const t = this.querySelector("[data-drawer-panel]");
    (t
      ? (t.classList.remove("animate-slide-in-right"),
        t.classList.add("animate-slide-out-right"),
        t.addEventListener(
          "animationend",
          () => {
            ((this.hidden = !0),
              this.classList.remove("pointer-events-auto"),
              (document.body.style.overflow = ""),
              t && f(t));
          },
          { once: !0 },
        ))
      : ((this.hidden = !0),
        this.classList.remove("pointer-events-auto"),
        (document.body.style.overflow = "")),
      document.removeEventListener("keydown", this._onKeydown));
  }
  _handleKeydown(t) {
    t.key === "Escape" && this._close();
  }
  _handleCartUpdate(t) {
    this.hidden || this._render(t.detail);
  }
  _render(t) {
    var i;
    const e = (t == null ? void 0 : t.items) || [],
      s = (t == null ? void 0 : t.item_count) || 0,
      n = (t == null ? void 0 : t.total_price) || 0;
    ((this.innerHTML = `
      <div class="fixed inset-0 bg-black/60 transition-opacity" data-drawer-backdrop></div>
      <div
        class="fixed top-0 right-0 bottom-0 w-full max-w-md bg-surface border-l border-border flex flex-col animate-slide-in-right"
        data-drawer-panel
        role="document"
      >
        <div class="flex items-center justify-between p-4 border-b border-border">
          <h2 class="text-lg font-heading font-bold text-text">${this._esc(this._t("cart.title"))} (${s})</h2>
          <button
            type="button"
            class="text-text hover:text-primary transition-colors p-1"
            data-close
            aria-label="${this._esc(this._t("accessibility.close_cart"))}"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
            </svg>
          </button>
        </div>

        <div class="flex-1 overflow-y-auto p-4">
          ${
            e.length > 0
              ? e.map((a) => this._renderItem(a)).join("")
              : `
            <div class="flex flex-col items-center justify-center h-full text-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" class="text-border mb-4" aria-hidden="true">
                <circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/>
                <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>
              </svg>
              <p class="text-text opacity-50">${this._esc(this._t("cart.empty"))}</p>
            </div>
          `
          }
        </div>

        ${
          e.length > 0
            ? `
          <div class="border-t border-border p-4 space-y-3">
            <div class="flex justify-between items-center">
              <span class="text-text font-bold">${this._esc(this._t("cart.subtotal"))}</span>
              <span class="text-lg font-bold text-primary">${p(n)}</span>
            </div>
            <p class="text-xs text-text opacity-40">${this._esc(this._t("cart.taxes_note"))}</p>
            <a
              href="/checkout"
              class="btn btn-primary w-full btn-lg"
            >${this._esc(this._t("cart.checkout"))}</a>
            <button
              type="button"
              class="btn btn-ghost w-full text-sm"
              data-close
            >${this._esc(this._t("cart.continue_shopping"))}</button>
          </div>
        `
            : ""
        }
      </div>
    `),
      this.querySelectorAll("[data-close]").forEach((a) => {
        a.addEventListener("click", () => this._close());
      }),
      (i = this.querySelector("[data-drawer-backdrop]")) == null ||
        i.addEventListener("click", () => this._close()),
      this.querySelectorAll("[data-line-key]").forEach((a) => {
        var c, l, h;
        const o = a.dataset.lineKey;
        ((c = a.querySelector('[data-action="decrease"]')) == null ||
          c.addEventListener("click", () => {
            var u;
            const d =
              parseInt(
                (u = a.querySelector("input")) == null ? void 0 : u.value,
                10,
              ) || 1;
            (d <= 1 ? w(o) : v(o, d - 1)).catch((e) =>
              document.dispatchEvent(
                new CustomEvent("cart:error", { detail: e.message }),
              ),
            );
          }),
          (l = a.querySelector('[data-action="increase"]')) == null ||
            l.addEventListener("click", () => {
              var u;
              const d =
                parseInt(
                  (u = a.querySelector("input")) == null ? void 0 : u.value,
                  10,
                ) || 1;
              v(o, d + 1).catch((e) =>
                document.dispatchEvent(
                  new CustomEvent("cart:error", { detail: e.message }),
                ),
              );
            }),
          (h = a.querySelector("[data-remove]")) == null ||
            h.addEventListener("click", () => {
              w(o).catch((e) =>
                document.dispatchEvent(
                  new CustomEvent("cart:error", { detail: e.message }),
                ),
              );
            }));
      }));
  }
  _renderItem(t) {
    const e = t.variant_title || "",
      s = t.image ? this._imageUrl(t.image, 120) : "";
    return `
      <div class="flex gap-3 py-3 border-b border-border" data-line-key="${this._esc(t.key)}">
        ${
          s
            ? `
          <a href="${t.url}" class="flex-shrink-0">
            <img
              src="${s}"
              alt="${this._esc(t.title)}"
              width="60"
              height="84"
              class="rounded object-contain"
              loading="lazy"
            >
          </a>
        `
            : ""
        }
        <div class="flex-1 min-w-0">
          <a href="${t.url}" class="text-sm font-bold text-text hover:text-primary transition-colors line-clamp-2">
            ${this._esc(t.product_title)}
          </a>
          ${e ? `<p class="text-xs text-text opacity-50 mt-0.5">${this._esc(e)}</p>` : ""}
          <p class="text-sm text-primary font-bold mt-1">${p(t.final_line_price)}</p>

          <div class="flex items-center gap-2 mt-2">
            <div class="inline-flex items-center border border-border rounded">
              <button
                type="button"
                class="px-2 py-1 text-xs text-text hover:text-primary transition-colors"
                data-action="decrease"
                aria-label="Decrease quantity"
              >−</button>
              <input
                type="number"
                value="${t.quantity}"
                min="0"
                class="w-8 text-center text-xs bg-transparent border-none p-0 text-text"
                aria-label="Quantity"
                readonly
              >
              <button
                type="button"
                class="px-2 py-1 text-xs text-text hover:text-primary transition-colors"
                data-action="increase"
                aria-label="Increase quantity"
              >+</button>
            </div>
            <button
              type="button"
              class="text-xs text-text opacity-40 hover:text-error hover:opacity-100 transition-colors"
              data-remove
              aria-label="Remove ${this._esc(t.title)}"
            >${this._t("cart.remove")}</button>
          </div>
        </div>
      </div>
    `;
  }
  _imageUrl(t, e) {
    return t
      ? t.includes("cdn.shopify.com")
        ? t.replace(/(\.\w+)(\?|$)/, `_${e}x$1$2`)
        : t
      : "";
  }
  _esc(t) {
    const e = document.createElement("div");
    return ((e.textContent = t || ""), e.innerHTML);
  }
  _t(t) {
    const e = t
      .replace(/[._]/g, "-")
      .replace(/-([a-z])/g, (s, n) => n.toUpperCase());
    return this.dataset[e] || t.split(".").pop().replace(/_/g, " ");
  }
}
customElements.define("tcg-cart-drawer", j);
class H extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    try {
      this._variants = JSON.parse(this.dataset.variants || "[]");
      this._names = JSON.parse(this.dataset.optionNames || "[]");
    } catch {
      return;
    }
    this._hiddenInput = this.querySelector('input[name="id"]');
    this._optionContainer = this.querySelector("[data-option-container]");
    this._priceEl = this.querySelector("[data-price]");
    this._stockEl = this.querySelector("[data-stock]");
    this._form = this.closest("form");
    this._selected =
      this._variants.find((v) => String(v.id) === this._hiddenInput?.value) ||
      this._variants.find((v) => v.available) ||
      this._variants[0];
    if (!this._selected) return;
    this._options = this._selected.options.map((_, index) => [
      ...new Set(this._variants.map((v) => v.options[index])),
    ]);
    this._render();
    this._update(false);
  }
  _esc(value) {
    return String(value ?? "").replace(
      /[&<>"']/g,
      (c) =>
        ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;",
        })[c],
    );
  }
  _candidate(index, value) {
    const candidates = this._variants.filter(
      (v) => v.available && v.options[index] === value,
    );
    return candidates.sort((a, b) => {
      const score = (v) =>
        v.options.reduce(
          (n, option, i) =>
            n + (i !== index && option === this._selected.options[i] ? 1 : 0),
          0,
        );
      return score(b) - score(a);
    })[0];
  }
  _render() {
    if (!this._optionContainer) return;
    this._optionContainer.innerHTML = this._options
      .map(
        (values, index) =>
          `<fieldset class="mb-4"><legend class="text-sm font-bold mb-2">${this._esc(this._names[index] || `Option ${index + 1}`)}</legend><div class="flex flex-wrap gap-2">${values
            .map((value) => {
              const available = !!this._candidate(index, value);
              const selected = this._selected.options[index] === value;
              return `<button type="button" class="bdf-option${selected ? " is-selected" : ""}" data-option-index="${index}" data-option-value="${this._esc(value)}" aria-pressed="${selected}" ${available ? "" : "disabled"}>${this._esc(value)}</button>`;
            })
            .join("")}</div></fieldset>`,
      )
      .join("");
    this._optionContainer
      .querySelectorAll("[data-option-index]")
      .forEach((button) =>
        button.addEventListener("click", () => {
          const next = this._candidate(
            Number(button.dataset.optionIndex),
            button.dataset.optionValue,
          );
          if (!next) return;
          this._selected = next;
          this._render();
          this._update(true);
        }),
      );
  }
  _update(updateUrl) {
    const variant = this._selected;
    if (this._hiddenInput) this._hiddenInput.value = variant.id;
    const text = window.Foil?.strings || {};
    const price = `<span class="text-2xl font-bold text-primary">${p(variant.price)}</span>${variant.compare_at_price > variant.price ? `<span class="text-lg line-through opacity-40">${p(variant.compare_at_price)}</span>` : ""}`;
    if (this._priceEl) this._priceEl.innerHTML = price;
    if (this._stockEl)
      this._stockEl.textContent = variant.available ? "" : text.sold_out;
    const submit = this._form?.querySelector('[type="submit"]');
    if (submit) {
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? text.add_to_cart : text.sold_out;
    }
    const sticky = this.closest("section")?.querySelector("[data-sticky-atc]");
    if (sticky) {
      const button = sticky.querySelector("[data-sticky-atc-btn]");
      if (button) {
        button.dataset.variantId = variant.id;
        button.disabled = !variant.available;
        button.textContent = variant.available
          ? text.add_to_cart
          : text.sold_out;
      }
      const amount = sticky.querySelector("[data-sticky-price]");
      if (amount) amount.innerHTML = p(variant.price);
    }
    const conditionIndex = this._names.findIndex((n) =>
      /condition|état/i.test(n),
    );
    const condition = this.closest("section")?.querySelector(
      "[data-selected-condition]",
    );
    if (condition && conditionIndex >= 0)
      condition.textContent = variant.options[conditionIndex];
    this.dispatchEvent(
      new CustomEvent("variant:change", { detail: { variant }, bubbles: true }),
    );
    if (updateUrl && this.dataset.url) {
      const url = new URL(location.href);
      url.searchParams.set("variant", variant.id);
      history.replaceState({}, "", url);
    }
  }
}
customElements.define("tcg-variant-picker", H);
class F extends HTMLElement {
  connectedCallback() {
    ((this._onOpen = this._open.bind(this)),
      document.addEventListener("search:open", this._onOpen),
      (this._debounceTimer = null),
      (this._abortController = null),
      (this._selectedIndex = -1));
  }
  disconnectedCallback() {
    document.removeEventListener("search:open", this._onOpen);
  }
  get _predictive() {
    return this.dataset.predictive === "true";
  }
  get _showCollections() {
    return this.dataset.showCollections === "true";
  }
  get _showPages() {
    return this.dataset.showPages === "true";
  }
  _open() {
    ((this.hidden = !1),
      (document.body.style.overflow = "hidden"),
      this._render(),
      requestAnimationFrame(() => {
        const t = this.querySelector("[data-search-input]");
        t && (_(this), t.focus());
      }));
  }
  _close() {
    ((this.hidden = !0),
      (document.body.style.overflow = ""),
      f(this),
      (this.innerHTML = ""));
  }
  _render() {
    var s, n, i, a;
    const t =
      ((n = (s = window.Foil) == null ? void 0 : s.routes) == null
        ? void 0
        : n.search_url) || "/search";
    ((this.innerHTML = `
      <div class="fixed inset-0 bg-black/70 animate-fade-in" data-search-backdrop></div>
      <div class="fixed inset-x-0 top-0 bg-surface border-b border-border shadow-xl animate-fade-in" data-search-panel>
        <div class="mx-auto max-w-2xl px-4 py-6">
          <form action="${t}" method="get" role="search" class="relative">
            <input
              type="search"
              name="q"
              placeholder="Search cards, sets, products..."
              autocomplete="off"
              class="w-full pl-10 pr-12 py-3 bg-background border border-border rounded-lg text-text text-lg focus:border-primary focus:outline-none"
              data-search-input
            >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="absolute left-3 top-1/2 -translate-y-1/2 text-text opacity-40 pointer-events-none" aria-hidden="true">
              <circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>
            </svg>
            <button
              type="button"
              class="absolute right-3 top-1/2 -translate-y-1/2 text-text opacity-40 hover:opacity-100 transition-opacity"
              data-search-close
              aria-label="Close search"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
              </svg>
            </button>
          </form>
          <div data-search-results class="mt-4 max-h-[60vh] overflow-y-auto"></div>
        </div>
      </div>
    `),
      (i = this.querySelector("[data-search-backdrop]")) == null ||
        i.addEventListener("click", () => this._close()),
      (a = this.querySelector("[data-search-close]")) == null ||
        a.addEventListener("click", () => this._close()));
    const e = this.querySelector("[data-search-input]");
    (e == null ||
      e.addEventListener("input", (o) => this._onInput(o.target.value)),
      e == null || e.addEventListener("keydown", (o) => this._onKeydown(o)));
  }
  _onInput(t) {
    var s;
    (clearTimeout(this._debounceTimer),
      (s = this._abortController) == null || s.abort());
    const e = t.trim();
    if (e.length < 2) {
      this._clearResults();
      return;
    }
    this._debounceTimer = setTimeout(() => {
      this._predictive && this._fetchPredictive(e);
    }, 250);
  }
  async _fetchPredictive(t) {
    var i, a, o;
    this._abortController = new AbortController();
    const { signal: e } = this._abortController,
      s = new URLSearchParams({
        q: t,
        "resources[type]": this._getResourceTypes(),
        "resources[limit]": "6",
      }),
      n = `${((a = (i = window.Foil) == null ? void 0 : i.routes) == null ? void 0 : a.predictive_search_url) || "/search/suggest"}.json?${s}`;
    try {
      const c = await fetch(n, { signal: e });
      if (!c.ok) return;
      const l = await c.json();
      this._renderResults(
        ((o = l.resources) == null ? void 0 : o.results) || {},
        t,
      );
    } catch (c) {
      c.name !== "AbortError" && console.error("Predictive search error:", c);
    }
  }
  _getResourceTypes() {
    const t = ["product"];
    return (
      this._showCollections && t.push("collection"),
      this._showPages && t.push("page"),
      t.join(",")
    );
  }
  _renderResults(t, e) {
    var l, h;
    const s = this.querySelector("[data-search-results]");
    if (!s) return;
    const n = t.products || [],
      i = t.collections || [],
      a = t.pages || [];
    if (n.length === 0 && i.length === 0 && a.length === 0) {
      s.innerHTML = `
        <p class="text-text opacity-50 text-center py-4">No results for "${this._esc(e)}"</p>
      `;
      return;
    }
    let o = "";
    ((this._selectedIndex = -1),
      n.length > 0 &&
        (o += `
        <div class="mb-4">
          <h3 class="text-xs font-bold text-text uppercase tracking-wide opacity-50 mb-2">Products</h3>
          <div class="space-y-1">
            ${n.map((d) => this._renderProductResult(d)).join("")}
          </div>
        </div>
      `),
      i.length > 0 &&
        (o += `
        <div class="mb-4">
          <h3 class="text-xs font-bold text-text uppercase tracking-wide opacity-50 mb-2">Collections</h3>
          <div class="space-y-1">
            ${i
              .map(
                (d) => `
              <a href="${d.url}" class="flex items-center gap-3 p-2 rounded hover:bg-background transition-colors" data-search-result>
                <span class="text-sm text-text">${this._esc(d.title)}</span>
              </a>
            `,
              )
              .join("")}
          </div>
        </div>
      `),
      a.length > 0 &&
        (o += `
        <div class="mb-4">
          <h3 class="text-xs font-bold text-text uppercase tracking-wide opacity-50 mb-2">Pages</h3>
          <div class="space-y-1">
            ${a
              .map(
                (d) => `
              <a href="${d.url}" class="flex items-center gap-3 p-2 rounded hover:bg-background transition-colors" data-search-result>
                <span class="text-sm text-text">${this._esc(d.title)}</span>
              </a>
            `,
              )
              .join("")}
          </div>
        </div>
      `));
    const c =
      ((h = (l = window.Foil) == null ? void 0 : l.routes) == null
        ? void 0
        : h.search_url) || "/search";
    ((o += `
      <a href="${c}?q=${encodeURIComponent(e)}" class="block text-center text-sm text-primary hover:underline py-2" data-search-result>
        View all results
      </a>
    `),
      (s.innerHTML = o));
  }
  _renderProductResult(t) {
    const e = t.image ? t.image.replace(/(\.\w+)(\?|$)/, "_100x$1$2") : "",
      s = t.price ? p(t.price) : "";
    return `
      <a href="${t.url}" class="flex items-center gap-3 p-2 rounded hover:bg-background transition-colors" data-search-result>
        ${
          e
            ? `
          <img
            src="${e}"
            alt="${this._esc(t.title)}"
            width="40"
            height="56"
            class="rounded object-contain flex-shrink-0"
            loading="lazy"
          >
        `
            : '<div class="w-10 h-14 bg-background rounded flex-shrink-0"></div>'
        }
        <div class="flex-1 min-w-0">
          <p class="text-sm font-bold text-text line-clamp-1">${this._esc(t.title)}</p>
          ${s ? `<p class="text-xs text-primary font-bold">${s}</p>` : ""}
        </div>
      </a>
    `;
  }
  _clearResults() {
    const t = this.querySelector("[data-search-results]");
    (t && (t.innerHTML = ""), (this._selectedIndex = -1));
  }
  _onKeydown(t) {
    const e = this.querySelectorAll("[data-search-result]");
    if (!(e.length === 0 && t.key !== "Escape"))
      switch (t.key) {
        case "Escape":
          (t.preventDefault(), this._close());
          break;
        case "ArrowDown":
          (t.preventDefault(),
            (this._selectedIndex = Math.min(
              this._selectedIndex + 1,
              e.length - 1,
            )),
            this._highlightResult(e));
          break;
        case "ArrowUp":
          (t.preventDefault(),
            (this._selectedIndex = Math.max(this._selectedIndex - 1, -1)),
            this._highlightResult(e));
          break;
        case "Enter":
          this._selectedIndex >= 0 &&
            e[this._selectedIndex] &&
            (t.preventDefault(), e[this._selectedIndex].click());
          break;
      }
  }
  _highlightResult(t) {
    (t.forEach((e, s) => {
      e.classList.toggle("bg-background", s === this._selectedIndex);
    }),
      this._selectedIndex >= 0 &&
        t[this._selectedIndex] &&
        t[this._selectedIndex].scrollIntoView({ block: "nearest" }));
  }
  _esc(t) {
    const e = document.createElement("div");
    return ((e.textContent = t || ""), e.innerHTML);
  }
}
customElements.define("tcg-search-modal", F);
class B extends HTMLElement {
  connectedCallback() {
    var t, e;
    ((this.input = this.querySelector('input[type="number"]')),
      this.input &&
        ((this.decreaseBtn = this.querySelector('[data-action="decrease"]')),
        (this.increaseBtn = this.querySelector('[data-action="increase"]')),
        (t = this.decreaseBtn) == null ||
          t.addEventListener("click", this._decrease.bind(this)),
        (e = this.increaseBtn) == null ||
          e.addEventListener("click", this._increase.bind(this)),
        this.input.addEventListener("change", this._onInputChange.bind(this))));
  }
  disconnectedCallback() {
    var t, e, s;
    ((t = this.decreaseBtn) == null ||
      t.removeEventListener("click", this._decrease),
      (e = this.increaseBtn) == null ||
        e.removeEventListener("click", this._increase),
      (s = this.input) == null ||
        s.removeEventListener("change", this._onInputChange));
  }
  get value() {
    var t;
    return parseInt((t = this.input) == null ? void 0 : t.value, 10) || 1;
  }
  set value(t) {
    if (!this.input) return;
    const e = parseInt(this.input.min, 10) || 1,
      s = parseInt(this.input.max, 10) || 99;
    ((this.input.value = Math.min(Math.max(t, e), s)), this._emit());
  }
  _decrease() {
    this.value = this.value - 1;
  }
  _increase() {
    this.value = this.value + 1;
  }
  _onInputChange() {
    this.value = this.value;
  }
  _emit() {
    this.dispatchEvent(
      new CustomEvent("quantity:change", {
        detail: { value: this.value },
        bubbles: !0,
      }),
    );
  }
}
customElements.define("tcg-quantity-input", B);
class P extends HTMLElement {
  connectedCallback() {
    var t, e, s;
    ((this._mainContainer = this.querySelector("[data-gallery-main]")),
      (this._mainImage = this.querySelector("[data-gallery-image]")),
      (this._thumbs = this.querySelectorAll("[data-thumb-index]")),
      (this._activeIndex = 0),
      (this._images = []),
      this._thumbs.forEach((n) => {
        const i = n.querySelector("img");
        this._images.push({
          id: n.dataset.imageId,
          src: n.dataset.fullSrc || (i == null ? void 0 : i.src) || "",
          alt: (i == null ? void 0 : i.alt) || "",
        });
      }),
      this._images.length === 0 &&
        this._mainImage &&
        this._images.push({
          src: this._mainImage.src,
          alt: this._mainImage.alt,
        }),
      this._thumbs.forEach((n) => {
        n.addEventListener("click", () => {
          this._setActive(parseInt(n.dataset.thumbIndex, 10));
        });
      }),
      this._mainContainer &&
        window.matchMedia("(hover: hover)").matches &&
        (this._mainContainer.addEventListener(
          "mousemove",
          this._onMouseMove.bind(this),
        ),
        this._mainContainer.addEventListener(
          "mouseleave",
          this._onMouseLeave.bind(this),
        ),
        (this._mainContainer.style.overflow = "hidden")),
      (this._touchStartX = 0),
      (t = this._mainContainer) == null ||
        t.addEventListener(
          "touchstart",
          (n) => {
            this._touchStartX = n.touches[0].clientX;
          },
          { passive: !0 },
        ),
      (e = this._mainContainer) == null ||
        e.addEventListener(
          "touchend",
          (n) => {
            const i = this._touchStartX - n.changedTouches[0].clientX;
            Math.abs(i) > 50 &&
              (i > 0 && this._activeIndex < this._images.length - 1
                ? this._setActive(this._activeIndex + 1)
                : i < 0 &&
                  this._activeIndex > 0 &&
                  this._setActive(this._activeIndex - 1));
          },
          { passive: !0 },
        ),
      (s = this.closest("section")) == null ||
        s.addEventListener("variant:change", (n) => {
          var a;
          const i = (a = n.detail) == null ? void 0 : a.variant;
          if (i != null && i.featured_image) {
            const o = this._images.findIndex(
              (c) =>
                String(c.id) === String(i.featured_image.id),
            );
            if (o >= 0) this._setActive(o);
            else if (i.featured_image.src && this._mainImage) { this._mainImage.src = i.featured_image.src; this._mainImage.alt = i.featured_image.alt || ""; }
          }
        }),
      (this._activeIndex = Math.max(0, this._images.findIndex(image => String(image.id) === String(this._mainImage?.dataset.imageId)))),
      this._updateThumbs());
  }
  _setActive(t) {
    t < 0 ||
      t >= this._images.length ||
      ((this._activeIndex = t),
      this._mainImage &&
        ((this._mainImage.src = this._images[t].src),
        (this._mainImage.alt = this._images[t].alt)),
      this._updateThumbs());
  }
  _updateThumbs() {
    this._thumbs.forEach((t, e) => {
      const s = e === this._activeIndex;
      (t.classList.toggle("ring-2", s),
        t.classList.toggle("ring-primary", s),
        t.classList.toggle("opacity-50", !s),
        t.setAttribute("aria-pressed", s));
    });
  }
  _onMouseMove(t) {
    if (!this._mainImage) return;
    const e = this._mainContainer.getBoundingClientRect(),
      s = ((t.clientX - e.left) / e.width) * 100,
      n = ((t.clientY - e.top) / e.height) * 100;
    ((this._mainImage.style.transformOrigin = `${s}% ${n}%`),
      (this._mainImage.style.transform = "scale(2)"),
      (this._mainImage.style.cursor = "zoom-in"));
  }
  _onMouseLeave() {
    this._mainImage &&
      ((this._mainImage.style.transform = ""),
      (this._mainImage.style.cursor = ""));
  }
}
customElements.define("tcg-product-gallery", P);
class D extends HTMLElement {
  connectedCallback() {
    var t, e, s;
    ((this._openBtn = document.querySelector("[data-mobile-menu-open]")),
      (this._closeBtn = this.querySelector("[data-mobile-menu-close]")),
      (this._backdrop = this.querySelector("[data-mobile-menu-backdrop]")),
      (this._panel = this.querySelector("[data-mobile-menu-panel]")),
      (this._onOpen = this._open.bind(this)),
      (this._onClose = this._close.bind(this)),
      (this._onKeydown = this._handleKeydown.bind(this)),
      (t = this._openBtn) == null || t.addEventListener("click", this._onOpen),
      (e = this._closeBtn) == null ||
        e.addEventListener("click", this._onClose),
      (s = this._backdrop) == null ||
        s.addEventListener("click", this._onClose));
  }
  disconnectedCallback() {
    var t, e, s;
    ((t = this._openBtn) == null ||
      t.removeEventListener("click", this._onOpen),
      (e = this._closeBtn) == null ||
        e.removeEventListener("click", this._onClose),
      (s = this._backdrop) == null ||
        s.removeEventListener("click", this._onClose),
      document.removeEventListener("keydown", this._onKeydown));
  }
  _open() {
    ((this.hidden = !1),
      (document.body.style.overflow = "hidden"),
      document.addEventListener("keydown", this._onKeydown),
      this._panel &&
        ((this._panel.style.transform = "translateX(-100%)"),
        requestAnimationFrame(() => {
          ((this._panel.style.transition = "transform 0.25s ease-out"),
            (this._panel.style.transform = "translateX(0)"));
        })),
      this._openBtn && this._openBtn.setAttribute("aria-expanded", "true"),
      requestAnimationFrame(() => {
        this._panel && _(this._panel);
      }));
  }
  _close() {
    (this._panel
      ? ((this._panel.style.transform = "translateX(-100%)"),
        this._panel.addEventListener(
          "transitionend",
          () => {
            ((this.hidden = !0),
              (document.body.style.overflow = ""),
              (this._panel.style.transition = ""),
              this._panel && f(this._panel));
          },
          { once: !0 },
        ))
      : ((this.hidden = !0), (document.body.style.overflow = "")),
      document.removeEventListener("keydown", this._onKeydown),
      this._openBtn && this._openBtn.setAttribute("aria-expanded", "false"));
  }
  _handleKeydown(t) {
    t.key === "Escape" && this._close();
  }
}
customElements.define("tcg-mobile-menu", D);
const $ = "foil:recently-viewed",
  E = 20;
function S() {
  try {
    return JSON.parse(localStorage.getItem($)) || [];
  } catch {
    return [];
  }
}
function R(r) {
  if (r)
    try {
      let t = S();
      ((t = t.filter((e) => e !== r)),
        t.unshift(r),
        t.length > E && (t.length = E),
        localStorage.setItem($, JSON.stringify(t)));
    } catch {}
}
class K extends HTMLElement {
  connectedCallback() {
    requestAnimationFrame(() => this._load());
  }
  async _load() {
    var o, c;
    const t = parseInt(this.dataset.limit, 10) || 8,
      e = this.dataset.currentHandle || "",
      s = this.querySelector("[data-recently-viewed-grid]");
    if (!s) return;
    const n = S()
      .filter((l) => l !== e)
      .slice(0, t);
    if (n.length === 0) {
      (o = this.closest("section")) == null || o.remove();
      return;
    }
    const a = (
      await Promise.all(
        n.map(async (l) => {
          try {
            const h = await fetch(`/products/${l}.json`);
            return h.ok ? (await h.json()).product : null;
          } catch {
            return null;
          }
        }),
      )
    ).filter(Boolean);
    if (a.length === 0) {
      (c = this.closest("section")) == null || c.remove();
      return;
    }
    s.innerHTML = a.map((l) => this._renderCard(l)).join("");
  }
  _renderCard(t) {
    var c, l, h, d, u, g, y, b;
    const e =
        ((c = t.image) == null ? void 0 : c.src) ||
        ((h = (l = t.images) == null ? void 0 : l[0]) == null
          ? void 0
          : h.src) ||
        "",
      s = e ? this._sizedImage(e, 400) : "",
      n =
        (u = (d = t.variants) == null ? void 0 : d[0]) != null && u.price
          ? p(Math.round(parseFloat(t.variants[0].price) * 100))
          : "",
      i =
        (y = (g = t.variants) == null ? void 0 : g[0]) != null &&
        y.compare_at_price
          ? p(Math.round(parseFloat(t.variants[0].compare_at_price) * 100))
          : "",
      a = `/products/${t.handle}`,
      o =
        ((b = t.variants) == null ? void 0 : b.some((I) => I.available)) ?? !0;
    return `
      <div class="flex-shrink-0 w-48 snap-start">
        <div class="group bg-surface border border-border rounded overflow-hidden hover:border-primary transition-colors">
          <a href="${a}" class="block">
            ${s ? `<img src="${this._esc(s)}" alt="${this._esc(t.title)}" width="400" height="560" class="w-full aspect-square object-contain" loading="lazy">` : '<div class="w-full card-aspect bg-background"></div>'}
          </a>
          <div class="p-3">
            <a href="${a}" class="block">
              <h3 class="text-sm font-bold text-text group-hover:text-primary transition-colors line-clamp-2 mb-1">
                ${this._esc(t.title)}
              </h3>
            </a>
            <div class="flex items-baseline gap-2">
              ${n ? `<span class="text-sm font-bold text-primary">${n}</span>` : ""}
              ${i && i !== n ? `<span class="text-xs text-text line-through opacity-40">${i}</span>` : ""}
            </div>
            ${o ? "" : '<p class="text-xs text-error font-bold mt-1">Sold out</p>'}
          </div>
        </div>
      </div>
    `;
  }
  _sizedImage(t, e) {
    return t
      ? t.includes("cdn.shopify.com")
        ? t.replace(/(\.\w+)(\?|$)/, `_${e}x$1$2`)
        : t
      : "";
  }
  _esc(t) {
    const e = document.createElement("div");
    return ((e.textContent = t || ""), e.innerHTML);
  }
}
customElements.define("tcg-recently-viewed", K);
function k() {
  const r = document.querySelector("[data-condition-modal]"),
    t = document.querySelector("[data-condition-modal-backdrop]"),
    e = document.querySelector("[data-condition-modal-close]"),
    s = document.querySelector("[data-condition-modal-content]"),
    n = document.querySelector("[data-condition-guide]"),
    i = document.querySelectorAll("[data-condition-guide-trigger]");
  if (!r || !n || i.length === 0) return;
  function a() {
    (s && (s.innerHTML = n.outerHTML),
      r.classList.remove("hidden"),
      r.classList.add("flex"),
      (document.body.style.overflow = "hidden"),
      requestAnimationFrame(() => {
        const l = r.querySelector(".relative.bg-surface");
        l && _(l);
      }),
      document.addEventListener("keydown", c));
  }
  function o() {
    (r.classList.add("hidden"),
      r.classList.remove("flex"),
      (document.body.style.overflow = ""),
      document.removeEventListener("keydown", c));
    const l = r.querySelector(".relative.bg-surface");
    l && f(l);
  }
  function c(l) {
    l.key === "Escape" && o();
  }
  (i.forEach((l) => l.addEventListener("click", a)),
    e && e.addEventListener("click", o),
    t && t.addEventListener("click", o));
}
document.readyState === "loading"
  ? document.addEventListener("DOMContentLoaded", k)
  : k();
window.Foil = window.Foil || {};
window.Foil._addRecentlyViewed = R;

